<template>
    <div class="alert alert-danger text-center" role="alert" style="width: 500px; background-color: #ff000030;">
        <span class="fw-bold fs-5" style="color: white;">플래너가 할당되지 않은 SNS고객이 {{ noPlannerCustomerCount }}명 있습니다.</span>
    </div>
</template>

<script>
export default {
    name: 'AlertVue',
    data() {
        return {

        }
    },
    props: {
        noPlannerCustomerCount: Number,
        isAlert: Boolean,
    },

    methods: {
        showNotification() {
            new Notification("SNS 고객 알림", {
                body: `[SNS 고객] 플래너가 할당되지 않은 고객이 ${this.noPlannerCustomerCount}명 있습니다.`,
                icon: "/img/icons/onmaum-512x512.png",
                //badge: "",
                //image: "",
                //actions: [],
                vibrate: [500, 100, 500]
            });
        }  
    },

    mounted() {
        this.showNotification();
    },

    updated() {
        this.showNotification();
    }
}
</script>

<style>

</style>
